import React, { useState, useEffect } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { withAuthorization } from 'components/Session';
import { CircularLoader, Button } from 'utils';
import ConfirmModal from './confirm-modal';
import CardDetailModal from './card-detail-modal';
import GiftCardForm from './gift-card-form';
import useGiftCard from './use-gift-card';
import getGCPayload from './utils/get-gc-payload';

import styles from './gift-card.module.scss';

function getImage(item) {
    switch (item.sku) {
        case 'EGCGBSRTPL001':
        case 'EGCGBAMZSVSRTP001':
            return item.id + '.jpg';
        default:
            return item.images.mobile;
    }
}

function GiftCard({ role, user, card }) {
    const [showModal, setShowModal] = useState(false);
    const [ShowCardDetailModal, setShowCardDetailModal] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const [formValues, setFormValues] = useState({});

    const {
        loading,
        isFetchingGc,
        gcSuccessMsg,
        gcOrderDetail,
        gcError,
        users,
        wallet,
        fetchUsers,
        purchaseGiftCard,
        handleGcReset
    } = useGiftCard({
        role,
        uniqueId: formValues.user?.ProfileUniqeID
    });

    useEffect(() => {
        setFormValues({
            user,
            quantity: 1,
            denomination:
                card.price?.type?.toLowerCase() === 'slab'
                    ? card.price.denominations[0]
                    : card.price.min
        });
    }, []);

    function handlePurchase() {
        const payload = getGCPayload({ user, formValues, card });
        purchaseGiftCard(payload);
    }

    
function scrollToTC(){
        setTabValue(1)
        const section = document.getElementById('tab_description');
            if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
            }
    }

    function getTabValue() {
        switch (tabValue) {
            case 0:
                return card.description;
            case 1:
                return card.tnc_content;
            case 2:
                return card.redeem;
            default:
                return null;
        }
    }

    return (
        <div className={styles.wrapper}>
            <p className={styles.balance}>
                {loading ? (
                    <CircularLoader size={20} style={{ marginRight: '40px' }} />
                ) : (
                    `Wallet balance: ₹ ${parseFloat(wallet?.walletbalance?.toFixed(2))}`
                )}
            </p>
            <div className={styles.content}>
                <div className={styles.card}>
                    <p className={styles.header}>{card.brandName}</p>
                    <p className={styles.subHeader}>SKU: {card.sku}</p>
                    {card.offer ? (
                        <p className={styles.description}>{card.offer}% off</p>
                    ) : null}
                    <div className={styles.image}>
                        <img
                            src={getImage(card)}
                            alt="base"
                            style={{ width: '100%', maxHeight: '240px' }}
                        />
                    </div>
                    
                     {card.sku =='EGCGBAMZSVSRTP001' || card.sku =='EGCGBSRTPL001'? (
                        <p className={styles.ama_condition}>Amazon Pay Gift Cards have Calendar month limit on Adding Gift cards. View <span onClick={scrollToTC}>T&C</span> for more information
                        </p>
                    ) : null}

                    {card.expiry ? (
                        <p className={styles.validity}>
                            Validity: {card.expiry}
                        </p>
                    ) : null}
                </div>
                <div>
                    <GiftCardForm
                        users={users}
                        formValues={formValues}
                        card={card}
                        setFormValues={setFormValues}
                        fetchUsers={fetchUsers}
                    />
                    <Button
                        label="Submit"
                        className={styles.button}
                        onClick={() => setShowModal(true)}
                    />
                </div>
            </div>
            <Box
                sx={{ borderBottom: 1, borderColor: 'divider' }}
                className="mb-3"
            >
                <Tabs
                    value={tabValue}
                    onChange={(e, value) => setTabValue(value)}
                >
                    <Tab label="Description" className="px-3 py-2" />
                    <Tab label="Terms & Conditions" className="px-3 py-2" />
                    {card.redeem ? (
                        <Tab label="HOW TO REDEEM" className="px-3 py-2" />
                    ) : null}
                </Tabs>
            </Box>
            <div
                className={styles.tabValue}
                dangerouslySetInnerHTML={{
                    __html: getTabValue()
                }}
            />
            {showModal ? (
                <ConfirmModal
                    isFetchingGc={isFetchingGc}
                    formValues={formValues}
                    card={card}
                    onConfirm={handlePurchase}
                    onClose={() => {
                        setShowModal(false);
                        handleGcReset();
                    }}
                    gcOrderDetail={gcOrderDetail}
                    gcSuccessMsg={gcSuccessMsg}
                    gcError={gcError}
                />
            ) : null}

            {ShowCardDetailModal ? (
                <CardDetailModal
                    gcOrderDetail={gcOrderDetail}
                    onClose={() => {
                        handleGcReset();
                        setShowCardDetailModal(false);
                    }}
                    
                    
                />
            ) : null}
        </div>
    );
}

const isAuthUser = (authUser) => !!authUser;
export default withAuthorization(isAuthUser)(GiftCard);
